import { Stack } from "@mantine/core";
import { useNavigate, useParams } from "react-router-dom";
import Actions from "src/components/Actions";
import EmployeeCard from "src/components/cards/Employee.Card";
import Loader from "src/components/Loader";
import useApi, { useGET } from "src/hooks/useApi";
import Employee from "src/types/Employee.type";
import TrackingSystem from "../../../lib/Tracking/TrackingSystem";

export default function RemoveEmployee() {
  const { id } = useParams();
  const api = useApi();

  const url = `res/employee/${id}`;
  const { data, isLoading, error } = useGET<Employee>(url);

  const navigate = useNavigate();
  const handleConfirm = () => {
    api.DELETE(`res/employee/${id}`);

      let ts = TrackingSystem.getInstance().sendCustomEvent("employee_deleted");
    navigate("/app");
  };
  const handleCancel = () => navigate(-1);

  if (error || (!isLoading && !data)) {
    navigate("/404");
  }

  return (
    <Stack align="center">
      Are you sure to remove this employee?
      <Loader isLoading={isLoading} error={error} hasData={!!data}>
        <EmployeeCard employee={data} />
      </Loader>
      <Actions
        actions={[
          {
            label: "cancel",
            onClick: handleCancel,
            variant: "default",
          },
          {
            label: "confirm",
            onClick: handleConfirm,
          },
        ]}
      />
    </Stack>
  );
}
